import { render, staticRenderFns } from "./EpiteliumGame.vue?vue&type=template&id=603fd69b&scoped=true"
import script from "./EpiteliumGame.vue?vue&type=script&lang=js"
export * from "./EpiteliumGame.vue?vue&type=script&lang=js"
import style0 from "./EpiteliumGame.vue?vue&type=style&index=0&id=603fd69b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "603fd69b",
  null
  
)

export default component.exports